import { Copy, Check } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";

const STATUS = {
  pending: ["En attente", "bg-zinc-800 text-zinc-300 border-zinc-700"],
  detected: ["Détecté (mempool)", "bg-blue-500/15 text-blue-400 border-blue-500/30"],
  confirmed: ["Confirmé", "bg-emerald-500/15 text-emerald-400 border-emerald-500/30"],
  overpaid: ["Sur-payé", "bg-emerald-500/15 text-emerald-300 border-emerald-500/30"],
  underpaid: ["Sous-payé", "bg-amber-500/15 text-amber-400 border-amber-500/30"],
  expired: ["Expiré", "bg-red-500/15 text-red-400 border-red-500/30"],
  delivered: ["Livré", "bg-emerald-500/15 text-emerald-400 border-emerald-500/30"],
  retrying: ["Nouvel essai", "bg-amber-500/15 text-amber-400 border-amber-500/30"],
  failed: ["Échec", "bg-red-500/15 text-red-400 border-red-500/30"],
  active: ["Actif", "bg-emerald-500/15 text-emerald-400 border-emerald-500/30"],
  suspended: ["Suspendu", "bg-red-500/15 text-red-400 border-red-500/30"],
};

export function StatusBadge({ status, testId }) {
  const [label, cls] = STATUS[status] || [status, "bg-zinc-800 text-zinc-300 border-zinc-700"];
  return <span data-testid={testId || `status-badge-${status}`} className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-[11px] font-mono font-medium tracking-wide border ${cls}`}>{label}</span>;
}

export function CopyButton({ value, label = "Copié", testId, className = "" }) {
  const [ok, setOk] = useState(false);
  const copy = async () => {
    try { await navigator.clipboard.writeText(value); } catch { /* fallback */ }
    setOk(true); toast.success(label); setTimeout(() => setOk(false), 1500);
  };
  return (
    <button type="button" onClick={copy} data-testid={testId} className={`inline-flex items-center gap-1.5 text-xs text-zinc-400 hover:text-amber-400 transition-colors active:scale-95 ${className}`}>
      {ok ? <Check size={14} className="text-emerald-400" /> : <Copy size={14} />}
    </button>
  );
}

export function PageHeader({ title, subtitle, children }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-6">
      <div>
        <h1 className="text-2xl sm:text-3xl font-bold tracking-tight">{title}</h1>
        {subtitle && <p className="text-sm text-zinc-400 mt-1 max-w-2xl">{subtitle}</p>}
      </div>
      {children && <div className="flex items-center gap-2">{children}</div>}
    </div>
  );
}

export function StatCard({ label, value, hint, testId, accent }) {
  return (
    <div className="panel p-5" data-testid={testId}>
      <div className="eyebrow">{label}</div>
      <div className={`mt-2 text-2xl font-heading font-bold tracking-tight ${accent || ""}`}>{value}</div>
      {hint && <div className="text-xs text-zinc-500 mt-1">{hint}</div>}
    </div>
  );
}

export function Empty({ text }) {
  return <div className="text-center text-sm text-zinc-500 py-10 border border-dashed border-zinc-800 rounded-lg">{text}</div>;
}
